var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 135,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m118.783 66.126-.114.244c-1.491 3.173-6.262 1.913-5.968-1.58a46 46 0 0 0-2.553-19.415C102.679 24.514 77.604.759 55.4.5c-2.371-.027-3.733 2.687-2.334 4.601a32 32 0 0 1 4.454 8.584c3.521 10.358 1.354 21.385-4.846 29.578-2.585 3.415-8.073 1.728-8.164-2.554l-.001-.093c-.037-2.27.336-4.45 1.05-6.468.315-.89-.51-1.767-1.414-1.494-12.588 3.794-22.16 22.317-22.16 35.53q.002 1.448.154 2.856c.012 1.754.309 3.54.928 5.295l.068.189q.29.809.61 1.599a56.6 56.6 0 0 1-7.524-11.987c-.932-2.007-3.882-1.609-4.244.574-.646 3.888-.983 7.68-.983 11.284 0 31.207 25.298 56.506 56.505 56.506s56.506-25.299 56.506-56.506c0-3.605-.337-7.397-.983-11.285-.362-2.178-3.31-2.586-4.239-.583"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M21.986 68.184q.002 1.448.153 2.856a16.2 16.2 0 0 0 .996 5.484c.193.54.399 1.07.61 1.599a56.6 56.6 0 0 1-7.524-11.988c-.931-2.006-3.881-1.608-4.244.575-.645 3.888-.983 7.68-.983 11.284 0 31.208 25.298 56.506 56.506 56.506 31.207 0 56.506-25.298 56.506-56.506 0-3.605-.338-7.397-.984-11.285-.362-2.178-3.31-2.586-4.239-.583l-.114.244c-1.491 3.173-6.262 1.913-5.968-1.58a46 46 0 0 0 .154-4.465H22.952c-.63 2.718-.966 5.382-.966 7.859"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M21.986 68.184q.002 1.448.153 2.856a16.2 16.2 0 0 0 .996 5.484c.193.54.399 1.07.61 1.599a56.6 56.6 0 0 1-7.524-11.988c-.931-2.006-3.881-1.608-4.244.575-.645 3.888-.983 7.68-.983 11.284 0 31.208 25.298 56.506 56.506 56.506 31.207 0 56.506-25.298 56.506-56.506 0-3.605-.338-7.397-.984-11.285-.362-2.178-3.31-2.586-4.239-.583l-.114.244c-1.491 3.173-6.262 1.913-5.968-1.58a46 46 0 0 0 .154-4.465H22.952c-.63 2.718-.966 5.382-.966 7.859"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M124.006 77.994c0-3.605-.338-7.397-.984-11.285-.362-2.178-3.31-2.586-4.239-.583l-.114.244c-1.491 3.173-6.262 1.913-5.968-1.58a46 46 0 0 0-2.553-19.415C102.679 24.514 77.605.759 55.4.5c-2.371-.027-3.733 2.687-2.333 4.602a32 32 0 0 1 4.453 8.583c3.522 10.358 1.354 21.385-4.846 29.578-1.287 1.7-3.294 2.136-4.996 1.616v86.043A56.4 56.4 0 0 0 67.5 134.5c31.207 0 56.506-25.299 56.506-56.506"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M119.7 99.66 82.966 62.927l-37.492 53.902 17.49 17.49q2.245.18 4.536.181c23.531 0 43.7-14.385 52.2-34.84"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "m96.127 87.629-.064.136c-.832 1.771-3.495 1.068-3.331-.882a25.7 25.7 0 0 0-1.426-10.837C87.137 64.4 73.14 51.14 60.746 50.996c-1.324-.015-2.084 1.5-1.303 2.569a17.8 17.8 0 0 1 2.486 4.791c1.966 5.782.756 11.937-2.705 16.51-1.443 1.907-4.506.966-4.557-1.425l-.001-.052c-.02-1.267.188-2.484.587-3.61a.644.644 0 0 0-.79-.834c-7.026 2.118-12.37 12.457-12.37 19.833q.001.807.086 1.594c.007.98.173 1.975.519 2.955l.037.106q.163.451.34.892a31.6 31.6 0 0 1-4.2-6.69c-.52-1.121-2.166-.898-2.369.32-.36 2.17-.548 4.287-.548 6.299 0 17.42 14.121 31.542 31.542 31.542s31.542-14.122 31.542-31.542c0-2.013-.189-4.13-.55-6.3-.2-1.215-1.847-1.443-2.365-.325"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M99.042 94.254c0-2.013-.189-4.13-.55-6.3-.201-1.215-1.847-1.443-2.366-.325l-.063.136c-.832 1.771-3.495 1.068-3.332-.882.3-3.565-.14-7.249-1.425-10.837C87.137 64.4 73.14 51.14 60.746 50.996c-1.325-.015-2.084 1.5-1.303 2.569a17.8 17.8 0 0 1 2.486 4.791c1.966 5.782.756 11.937-2.705 16.51-.719.95-1.839 1.193-2.789.903v48.03a31.5 31.5 0 0 0 11.065 1.997c17.42 0 31.542-14.122 31.542-31.542"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M42.093 88.778q.001.807.086 1.594c.007.98.173 1.975.519 2.955l.037.106q.163.45.34.892a31.6 31.6 0 0 1-4.2-6.69c-.52-1.121-2.166-.899-2.369.32-.36 2.17-.548 4.286-.548 6.299 0 17.42 14.121 31.542 31.542 31.542s31.542-14.122 31.542-31.543c0-2.012-.189-4.129-.55-6.299-.201-1.215-1.847-1.443-2.366-.325l-.063.136c-.832 1.771-3.495 1.068-3.332-.883q.105-1.238.086-2.492H42.633c-.352 1.518-.54 3.005-.54 4.388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M42.093 88.778q.001.807.086 1.594c.007.98.173 1.975.519 2.955l.037.106q.163.45.34.892a31.6 31.6 0 0 1-4.2-6.69c-.52-1.121-2.166-.899-2.369.32-.36 2.17-.548 4.286-.548 6.299 0 17.42 14.121 31.542 31.542 31.542s31.542-14.122 31.542-31.543c0-2.012-.189-4.129-.55-6.299-.201-1.215-1.847-1.443-2.366-.325l-.063.136c-.832 1.771-3.495 1.068-3.332-.883q.105-1.238.086-2.492H42.633c-.352 1.518-.54 3.005-.54 4.388"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M17.035 47.432c4.134.848 7.428-3.404 5.778-7.288a9.75 9.75 0 0 1 .83-9.198 1.216 1.216 0 0 0-.74-1.863c-3.853-.868-8.012.67-10.307 4.168-2.959 4.508-1.703 10.56 2.805 13.52.505.33 1.056.543 1.634.661"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M17.035 47.432c4.134.848 7.428-3.404 5.778-7.288a9.75 9.75 0 0 1 .83-9.198 1.216 1.216 0 0 0-.74-1.863c-3.853-.868-8.012.67-10.307 4.168-2.959 4.508-1.703 10.56 2.805 13.52.505.33 1.056.543 1.634.661"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M17.035 47.432c4.134.848 7.428-3.404 5.778-7.288a9.75 9.75 0 0 1 .83-9.198 1.216 1.216 0 0 0-.74-1.863c-3.853-.868-8.012.67-10.307 4.168-2.959 4.508-1.703 10.56 2.805 13.52.505.33 1.056.543 1.634.661"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 38.223,
    x2: 93.491,
    y1: 46.714,
    y2: 101.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 80.09,
    x2: 99.68,
    y1: 98.095,
    y2: 121.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 65.725,
    x2: 62.18,
    y1: 97.143,
    y2: 135.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 81.368,
    x2: 116.443,
    y1: 61.059,
    y2: 45.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 109.971,
    x2: 67.059,
    y1: 125.975,
    y2: 94.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 54.546,
    x2: 79.919,
    y1: 78.706,
    y2: 108.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fef0ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fac600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 81.871,
    x2: 90.453,
    y1: 83.103,
    y2: 80.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 58.741,
    x2: 52.398,
    y1: 110.173,
    y2: 120.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 75.055,
    x2: 80.03,
    y1: 111.216,
    y2: 121.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe9738",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 13.795,
    x2: 25.362,
    y1: 33.388,
    y2: 43.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa1ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4565"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 16.876,
    x2: 14.264,
    y1: 40.65,
    y2: 47.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 16.809,
    x2: 25.298,
    y1: 37.329,
    y2: 39.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fe0364",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#f90362",
    stopOpacity: 0.234
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#ea035b",
    stopOpacity: 0.517
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#d20250",
    stopOpacity: 0.824
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5.5h134v134H.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.d960601eb7095559f6cd0bf745cbbec2.svg";
export { ForwardRef as ReactComponent };